export enum SearchResultType {
  Thread = 'Thread',
  Group = 'Group',
  User = 'User',
  File = 'File',
  Inbox = 'Inbox',
  Topic = 'Topic',
  NetworkQuestion = 'NetworkQuestion',
  PublisherNetworkQuestion = 'PublisherNetworkQuestion',
  Campaign = 'Campaign',
}

export interface SearchFilters {
  readonly groupScope?: string;
  readonly campaignId?: string;
  readonly startDate?: number;
  readonly endDate?: number;
  readonly networkId?: string;
  readonly participantUserIds?: string[];
  readonly threadStarterSenderId?: string;
}

export interface SearchLocationParameters {
  readonly searchText?: string;
  readonly resultType?: SearchResultType;
  readonly groupScope?: string;
  readonly campaignId?: string;
  readonly startDate?: number;
  readonly endDate?: number;
  readonly networkId?: string;
  readonly participantUserIds?: string[];
  readonly threadStarterSenderId?: string;
  readonly postType?: string;
}
